import { IMessage } from '@/app/shared/models/chat/chat.model'
import { DatePipe } from '@angular/common'

export class ChatMessageUtils {
  static groupMessages(messages: IMessage[], datePipe: DatePipe) {
    const groups: { label: string; messages: IMessage[] }[] = []

    messages.forEach((m) => {
      const label = this.getGroupLabel(m.timestamp, datePipe)
      const existingGroup = groups.find((g) => g.label === label)
      if (existingGroup) {
        existingGroup.messages.push(m)
      } else {
        groups.push({ label, messages: [m] })
      }
    })

    return groups
  }

  private static getGroupLabel(date: Date, datePipe: DatePipe): string {
    const today = new Date()
    const yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)

    if (this.isSameDay(date, today)) return "Aujourd'hui"
    if (this.isSameDay(date, yesterday)) return 'Hier'

    return datePipe.transform(date, 'd MMMM yyyy') || ''
  }

  static sortMessages(messages: IMessage[]): IMessage[] {
    return [...messages].sort((a, b) => {
      const timeA = a.timestamp.getTime()
      const timeB = b.timestamp.getTime()

      if (timeA !== timeB) {
        return timeA - timeB
      }

      // Tie-breaker: ID (assumes higher ID is later)
      // Positive IDs (from API) vs 0 (optimistic)
      if (a.id !== b.id) {
        return a.id - b.id
      }

      return 0
    })
  }

  static formatConversationTimestamp(date: Date, datePipe: DatePipe): string {
    const today = new Date()
    const yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)

    if (this.isSameDay(date, today)) {
      return datePipe.transform(date, 'HH:mm:ss') || ''
    }

    if (this.isSameDay(date, yesterday)) {
      return `Hier ${datePipe.transform(date, 'HH:mm:ss')}`
    }

    return datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss') || ''
  }

  private static isSameDay(d1: Date, d2: Date): boolean {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    )
  }
}
